import { forwardRef } from 'react';
import { BaseTypeMap, Component, ComponentProps } from '../types/Component';
import { Input, InputProps } from '../Input';

export type RadioGroupItemTypeMap = BaseTypeMap<
  'input',
  Omit<InputProps, 'name' | 'onChange' | 'type'> & {
    name?: string;
    onChange?: InputProps['onChange'];
  }
>;

export type RadioGroupItemProps = ComponentProps<RadioGroupItemTypeMap>;

export const RadioGroupItem: Component<RadioGroupItemTypeMap> = forwardRef(
  function RadioGroupItem({ name = '', ...rest }, ref) {
    return <Input ref={ref} {...rest} name={name} type="radio" />;
  }
);
